import React, { FC, useState } from "react";
import { Outlet } from "react-router-dom";
import { Container } from "@mui/material";
import Drawer from "./Drawer";
import TablePageHeader from "./TablePageHeader";

/**
 * The Tables route element. Includes Header and Drawer Elements, tables are placed inside using
 * react-routers Outlet component.
 */
const TablePageLayout: FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Drawer open={drawerOpen} handleOpenChange={setDrawerOpen}>
      <TablePageHeader
        onNameClick={() => setDrawerOpen(true)}
        drawerOpen={drawerOpen}
      />
      <Container
        maxWidth={false}
        style={{
          height: "calc(100%  - 110px)",
          backgroundColor: "transparent",
          overflowY: "auto",
        }}
        component="main"
        disableGutters
      >
        <Outlet />
      </Container>
    </Drawer>
  );
};

export default TablePageLayout;
